module.exports = __webpack_public_path__ + "static/media/Fs2v6.7e850fa0.mp3";